module.exports = __webpack_public_path__ + "img/content-bottom-image.4d99ce66.svg";